import { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

// Accept retired flag keys long enough for stale merchant app bundles to
// refresh without turning features off or failing RPC input validation.
export const deprecatedAlwaysOnFeatureFlagKeys = ["ask-redo-ui"] as const;
export type DeprecatedAlwaysOnFeatureFlagKey =
  (typeof deprecatedAlwaysOnFeatureFlagKeys)[number];

export const getFeatureFlag = {
  name: "getFeatureFlag" as const,
  input: z.object({
    flagKey: z.union([
      createEnum(FeatureFlagKey),
      z.enum(deprecatedAlwaysOnFeatureFlagKeys),
    ]),
    defaultValue: z.boolean().nullish(),
  }),
  output: z.object({ enabled: z.boolean() }),
};
